import React from "react";

export const Error404 = () => {
  return (
    <div className="box-404">
      <img className="png-404" src="./404.png" alt="not found" />
    </div>
  );
};
